"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const uuid_1 = __importDefault(require("uuid"));
const expressions_1 = require("@mwater/expressions");
const AxisBuilder_1 = __importDefault(require("../../../axes/AxisBuilder"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_ui_2 = require("@mwater/expressions-ui");
const OrderingsComponent_1 = __importDefault(require("./OrderingsComponent"));
const expressions_ui_3 = require("@mwater/expressions-ui");
const ReorderableListComponent_1 = __importDefault(require("@mwater/react-library/lib/reorderable/ReorderableListComponent"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const valueFormatter_1 = require("../../../valueFormatter");
const valueFormatter_2 = require("../../../valueFormatter");
const AxisComponent_1 = __importDefault(require("../../../axes/AxisComponent"));
const expressions_ui_4 = require("@mwater/expressions-ui");
class TableChartDesignerComponent extends react_1.default.Component {
    // Updates design with the specified changes
    updateDesign(changes) {
        const design = lodash_1.default.extend({}, this.props.design, changes);
        this.props.onDesignChange(design);
    }
    handleTitleTextChange = (ev) => {
        this.updateDesign({ titleText: ev.target.value });
    };
    handleTableChange = (table) => {
        this.updateDesign({ table });
    };
    handleFilterChange = (filter) => {
        this.updateDesign({ filter });
    };
    handleOrderingsChange = (orderings) => {
        this.updateDesign({ orderings });
    };
    handleLimitChange = (limit) => {
        this.updateDesign({ limit });
    };
    handleColumnChange = (index, column) => {
        const columns = this.props.design.columns.slice();
        columns[index] = column;
        this.updateDesign({ columns });
    };
    handleRemoveColumn = (index) => {
        const columns = this.props.design.columns.slice();
        columns.splice(index, 1);
        this.updateDesign({ columns });
    };
    handleAddColumn = () => {
        const columns = this.props.design.columns.slice();
        columns.push({ id: (0, uuid_1.default)() });
        this.updateDesign({ columns });
    };
    renderTable() {
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" },
                react_1.default.createElement("i", { className: "fa fa-database" }),
                " ",
                T `Data Source`),
            ": ",
            react_1.default.createElement(expressions_ui_3.TableSelectComponent, { schema: this.props.schema, value: this.props.design.table, onChange: this.handleTableChange, filter: this.props.design.filter, onFilterChange: this.handleFilterChange })));
    }
    renderTitle() {
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" }, T `Title`),
            react_1.default.createElement("input", { type: "text", className: "form-control form-control-sm", value: this.props.design.titleText, onChange: this.handleTitleTextChange, placeholder: T `Untitled` })));
    }
    renderColumn = (column, index, connectDragSource, connectDragPreview, connectDropTarget) => {
        const style = {
            borderTop: "solid 1px #EEE",
            paddingTop: 10,
            paddingBottom: 10
        };
        return connectDragPreview(connectDropTarget(react_1.default.createElement("div", { key: index, style: style },
            react_1.default.createElement(TableChartColumnDesignerComponent, { design: this.props.design, schema: this.props.schema, dataSource: this.props.dataSource, index: index, onChange: this.handleColumnChange.bind(null, index), onRemove: this.handleRemoveColumn.bind(null, index), connectDragSource: connectDragSource }))));
    };
    handleReorder = (map) => {
        return this.updateDesign({ columns: map });
    };
    renderColumns() {
        if (!this.props.design.table) {
            return;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ReorderableListComponent_1.default, { items: this.props.design.columns, onReorder: this.handleReorder, renderItem: this.renderColumn, getItemId: (item) => item.id }),
            react_1.default.createElement("button", { className: "btn btn-secondary btn-sm", type: "button", onClick: this.handleAddColumn },
                react_1.default.createElement("span", { className: "fas fa-plus" }),
                " ",
                T `Add Column`)));
    }
    // return R 'div', className: "form-group",
    //   _.map(@props.design.columns, (column, i) => @renderColumn(i))
    //
    renderOrderings() {
        // If no table, hide
        if (!this.props.design.table) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" },
                react_1.default.createElement("span", { className: "fas fa-sort-amount-down" }),
                " ",
                T `Ordering`),
            react_1.default.createElement("div", { style: { marginLeft: 8 } },
                react_1.default.createElement(OrderingsComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, orderings: this.props.design.orderings, onOrderingsChange: this.handleOrderingsChange, table: this.props.design.table }))));
    }
    renderFilter() {
        // If no table, hide
        if (!this.props.design.table) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" },
                react_1.default.createElement("span", { className: "fas fa-filter" }),
                " ",
                T `Filters`),
            react_1.default.createElement("div", { style: { marginLeft: 8 } },
                react_1.default.createElement(expressions_ui_2.FilterExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, onChange: this.handleFilterChange, table: this.props.design.table, value: this.props.design.filter }))));
    }
    renderLimit() {
        // If no table, hide
        if (!this.props.design.table) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" }, T `Maximum Number of Rows (up to 1000)`),
            react_1.default.createElement("div", { style: { marginLeft: 8 } },
                react_1.default.createElement(ui.NumberInput, { value: this.props.design.limit, onChange: this.handleLimitChange, decimal: false, placeholder: "1000" }))));
    }
    render() {
        return (react_1.default.createElement("div", null,
            this.renderTable(),
            this.renderColumns(),
            this.props.design.table ? react_1.default.createElement("hr", null) : undefined,
            this.renderOrderings(),
            this.renderFilter(),
            this.renderLimit(),
            react_1.default.createElement("hr", null),
            this.renderTitle()));
    }
}
exports.default = TableChartDesignerComponent;
class TableChartColumnDesignerComponent extends react_1.default.Component {
    static contextType = expressions_ui_4.LocaleContext;
    // Updates column with the specified changes
    updateColumn(changes) {
        const column = lodash_1.default.extend({}, this.props.design.columns[this.props.index], changes);
        return this.props.onChange(column);
    }
    updateTextAxis(changes) {
        const textAxis = lodash_1.default.extend({}, this.props.design.columns[this.props.index].textAxis, changes);
        return this.updateColumn({ textAxis });
    }
    handleExprChange = (expr) => {
        return this.updateTextAxis({ expr });
    };
    handleHeaderTextChange = (ev) => {
        return this.updateColumn({ headerText: ev.target.value });
    };
    handleAggrChange = (aggr) => {
        return this.updateTextAxis({ aggr });
    };
    handleFormatChange = (ev) => {
        return this.updateColumn({ format: ev.target.value });
    };
    renderRemove() {
        if (this.props.design.columns.length > 1) {
            return (react_1.default.createElement("button", { className: "btn btn-sm btn-link float-end", type: "button", onClick: this.props.onRemove },
                react_1.default.createElement("span", { className: "fas fa-times" })));
        }
        return null;
    }
    renderExpr() {
        const column = this.props.design.columns[this.props.index];
        const title = T `Value`;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", { className: "text-muted" }, title),
            ": ",
            react_1.default.createElement(expressions_ui_1.ExprComponent, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.design.table, value: column.textAxis ? column.textAxis.expr : null, onChange: this.handleExprChange, aggrStatuses: ["literal", "individual", "aggregate"] })));
    }
    renderFormat() {
        const column = this.props.design.columns[this.props.index];
        // Get type
        const exprUtils = new expressions_1.ExprUtils(this.props.schema);
        const exprType = exprUtils.getExprType(column.textAxis?.expr ?? null);
        if (!exprType) {
            return null;
        }
        const formats = (0, valueFormatter_1.getFormatOptions)(exprType);
        if (!formats) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("label", { className: "text-muted" }, T `Format`),
            ": ",
            react_1.default.createElement("select", { value: column.format != null ? column.format : (0, valueFormatter_2.getDefaultFormat)(exprType), className: "form-select", style: { width: "auto", display: "inline-block" }, onChange: this.handleFormatChange }, lodash_1.default.map(formats, (format) => react_1.default.createElement("option", { key: format.value, value: format.value }, format.label)))));
    }
    renderHeader() {
        const column = this.props.design.columns[this.props.index];
        const axisBuilder = new AxisBuilder_1.default({ schema: this.props.schema });
        const placeholder = column.textAxis ? axisBuilder.summarizeAxis(column.textAxis ?? null, this.context) : "";
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", { className: "text-muted" }, T `Header`),
            ": ",
            react_1.default.createElement("input", { type: "text", className: "form-control form-control-sm", style: { display: "inline-block", width: "15em" }, value: column.headerText, onChange: this.handleHeaderTextChange, placeholder: placeholder })));
    }
    renderSummarize() {
        const column = this.props.design.columns[this.props.index];
        const exprUtils = new expressions_1.ExprUtils(this.props.schema);
        const exprType = exprUtils.getExprType(column.textAxis?.expr ?? null);
        if (!exprType || exprType !== 'number') {
            return null;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ui.Checkbox, { value: column.summarize, inline: true, onChange: (summarize) => this.updateColumn({ summarize, summaryType: column.summaryType ?? 'sum' }) }, T `Summarize`),
            column.summarize ?
                react_1.default.createElement("div", null,
                    react_1.default.createElement("label", { className: "text-muted" }, T `Summary Type`),
                    ": ",
                    react_1.default.createElement(ui.Select, { inline: true, value: column.summaryType, onChange: (summaryType) => this.updateColumn({ summaryType }), options: [{ value: 'avg', label: T `Average` }, { value: 'sum', label: T `Sum` }, { value: 'min', label: T `Minimum` }, { value: 'max', label: T `Maximum` }] }))
                : undefined));
    }
    renderBackgroundColorAxis() {
        const column = this.props.design.columns[this.props.index];
        if (!column.textAxis)
            return null;
        return (react_1.default.createElement(ui.CollapsibleSection, { label: T `Background color by data`, labelMuted: true },
            react_1.default.createElement(AxisComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, table: this.props.design.table, types: ["enum", "text", "boolean", "date"], value: column.backgroundColorAxis, onChange: (backgroundColorAxis) => this.updateColumn({ backgroundColorAxis }), showColorMap: true, aggrNeed: "optional" })));
    }
    render() {
        const iconStyle = {
            cursor: "move",
            marginRight: 8,
            opacity: 0.5,
            fontSize: 12,
            height: 20
        };
        return (react_1.default.createElement("div", null,
            this.props.connectDragSource(react_1.default.createElement("i", { className: "fa fa-bars", style: iconStyle })),
            this.renderRemove(),
            react_1.default.createElement("label", null, T `Column ${this.props.index + 1}`),
            react_1.default.createElement("div", { style: { marginLeft: 5 } },
                this.renderExpr(),
                this.renderFormat(),
                this.renderHeader(),
                this.renderSummarize(),
                this.renderBackgroundColorAxis())));
    }
}
